<template>
  <div>
    <NavBar />
    <div class="container-fluid px-5 mb-4">
      <div class="row">
        <div class="col">
          <h1>
            {{ title }}
            <span class="badge rounded mx-2" :class="statusCssClass">{{ investigation.statusShortDescription }}</span>
          </h1>
        </div>
        <div class="col-auto ml-auto">
          <CloseButton v-if="showCloseButton" :investigation="investigation" :isLoading="isLoading" @reload="load" />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div v-if="successMessage" class="alert alert-success alert-dismissible fade show mt-4" role="alert">
            {{ successMessage }}
            <button type="button" class="close" @click="successMessage = null" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ErrorSummary :error="error" />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <Description :investigation="investigation" :isLoading="isLoading" @reload="load" />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <Attributes :investigation="investigation" :isLoading="isLoading" @reload="load" />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <Collaborators :investigation="investigation" :isLoading="isLoading" @reload="load" />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <InterviewDetails :investigation="investigation" :isLoading="isLoading" @reload="load" />
        </div>
      </div>

      <div class="row mt-4">
        <div class="col">
          <InterviewStatistics v-if="!isLoading" :investigation="investigation" :isLoading="isLoading" @reload="load" />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col">
          <Interviews :investigation="investigation" :isLoading="isLoading" @reload="load" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NavBar from "@/views/reports/NavBar.vue";
import ErrorSummary from "@/components/ErrorSummary.vue";
import formatter from "@/utils/formatter";
import Description from "@/views/reports/investigations/edit-investigation/Description.vue";
import Attributes from "@/views/reports/investigations/edit-investigation/Attributes.vue";
import Collaborators from "@/views/reports/investigations/edit-investigation/Collaborators.vue";
import InterviewDetails from "@/views/reports/investigations/edit-investigation/InterviewDetails.vue";
import InterviewStatistics from "@/views/reports/investigations/edit-investigation/InterviewStatistics.vue";
import Interviews from "@/views/reports/investigations/edit-investigation/Interviews.vue";
import CloseButton from "@/views/reports/investigations/edit-investigation/CloseButton.vue";

export default {
  components: {
    NavBar,
    ErrorSummary,
    Description,
    Attributes,
    Collaborators,
    InterviewDetails,
    Interviews,
    InterviewStatistics,
    CloseButton,
  },
  props: {
    organizationId: String,
    investigationId: String,
  },
  data() {
    return {
      loadingMessage: null,
      successMessage: null,
      error: null,

      investigation: {},
    };
  },
  computed: {
    ...mapGetters("role", ["isVerensicsAdministrator", "isOrganizationAdministrator", "isInvestigationCreator"]),
    formatter: () => formatter,
    isLoading() {
      return !!this.loadingMessage;
    },
    isOpen() {
      return this.investigation.statusCode === "open";
    },
    isClosed() {
      return this.investigation.statusCode === "closed";
    },
    showCloseButton() {
      return this.isVerensicsAdministrator || this.isOrganizationAdministrator || this.isInvestigationCreator;
    },
    title() {
      if (!this.investigation) return null;
      if (this.investigation.name) return this.investigation.name;
      return null;
    },
    statusCssClass() {
      if (this.isOpen) return "badge-info";
      if (this.isClosed) return "badge-success";
      return "badge-secondary";
    },
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loadingMessage = "Loading...";
      this.$axios
        .get(`/v1/organizations/${this.organizationId}/investigations/${this.investigationId}`)
        .then(res => (this.investigation = res.data))
        .catch(err => {
          if (err.response.status === 404) this.$router.push(`/organizations/${this.organizationId}/investigations`);
          this.error = err;
        })
        .finally(() => (this.loadingMessage = null));
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  .badge {
    font-size: 40%;
    vertical-align: super;
  }
}
</style>
